import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {ToxicDigitsFixToEnglish, ToxicIntTryParse} from "../../../components/techaran/money";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const StudentsConsentVerifyModal = (props: { active: boolean, closeHandler: any, consentNd:string, title:string, onDone:any }) => {
    const fetchData = (consentNd:string) => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/parents/consents/send',
            {
                nd:consentNd,
            },
            true,
            (d: {
                result:string,
                reason:string,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectParents();
                    props.closeHandler();
                    props.onDone();
                    return;
                }
            },
            ()=>{},
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        const nd = props.consentNd;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            fetchData(nd);
            setCode('');
            setErr('');
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const codeId = useId();
    const [code,setCode] = useState('');
    const [err,setErr] = useState('');
    const checkCode = () => {
        const nd = props.consentNd;
        const c = code.trim();
        if(c.length < 5 || !ToxicIntTryParse(c)){
            setErr('لطفا کد تایید را به درستی وارد نمایید.');
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/parents/consents/verify',
            {
                nd:nd,
                code:c,
            },
            true,
            (d: {
                result:string,
                reason:string,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectParents();
                    else if(d.reason === 'fill')
                        setErr('لطفا کد تایید را به درستی وارد نمایید.');
                    else if(d.reason === 'wrong'){
                        setCode('');
                        setErr('کد وارد شده اشتباه بود، یک کد جدید برای شما پیامک گردید، لطفا آن را وارد نمایید.')
                    }
                    return;
                }
                ShowSnackbar(
                    'رضایت‌نامه برای دانش‌آموز امضا شد.',
                    'باشه',
                    5000,
                );
                props.closeHandler();
                props.onDone();
            },
            ()=>{},
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal web-modal-sm" + (props.active ? ' active' : '')}>
                <div className="web-modal-header">
                    <div><b>امضای رضایت‌نامه</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <span style={{display:'block',margin:'0 0 20px 0',color:'#0a53be',fontWeight:400,fontSize:14}}>برای امضا رضایت‌نامه مربوط به {props.title}، لطفا کد پیامک شده را در کادر زیر وارد نمایید:</span>
                        <label htmlFor={codeId}>کد دریافتی:</label>
                        <input type="text"
                               id={codeId}
                               value={code}
                               onChange={e=>{
                                   const t = e.currentTarget.value.trim();
                                   setCode(ToxicDigitsFixToEnglish(t));
                                   setErr('');
                               }}
                               onKeyUp={e=>{
                                   if(e.which === 13)
                                       checkCode();
                               }}
                               className={"form-control text-center" + (err !== '' ? ' is-invalid':'')}
                        />
                        <div className={"invalid-feedback" + (err !== '' ? ' d-block':' d-none')}>
                            {err}
                        </div>
                        <div className="d-flex justify-content-end align-items-center" style={{gap:5,marginTop:20}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={checkCode}>
                                <b>تایید و امضا</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};